import { actions as visibilityActions, reducer as visibilityReducer } from './visibility.slice';

export const actions = visibilityActions;

export default visibilityReducer;
